import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { ReportConfigService } from 'data-ng-custom-text';
import { PriorityFeedCapabilityConfiguration } from '../configuration';

angular
  .module('capability-ng-priority-feed')
  .factory(
    'loadPriorityFeedDataCommand',
    (
      $q: ng.IQService,
      defineCommand: IDefineCommand,
      getStudyBuddyPriorityFeedCommand: ICommand,
      ngPriorityFeedCapabilityConfiguration: PriorityFeedCapabilityConfiguration,
      loadHoldsListCommand: ICommand,
      courseListCommand: ICommand,
      loadConversationsCommand: ICommand,
      loadAllReminderDateRangeCommand: ICommand,
      loadPathTasksCommand: ICommand,
      loadActiveSurveysCommand: ICommand,
      loadStaffTodoCommand: ICommand,
      loadAllReportsCommand: ICommand,
      ngReportConfigService: ReportConfigService
    ): ICommand => {
      const dateRange = {
        start: moment().format('YYYY-MM-DD'),
        end: moment().add(2, 'w').format('YYYY-MM-DD')
      };
      const promiseStub = () => $q.defer() as any;

      return defineCommand('loadPriorityFeedDataCommand', (deferred: ng.IDeferred<IQuery[]>): void => {
        $q.all({
          studyBuddies: ngPriorityFeedCapabilityConfiguration.config.isStudyGroupEnabled
            ? getStudyBuddyPriorityFeedCommand()
            : promiseStub().resolve(),
          holds: ngPriorityFeedCapabilityConfiguration.config.isHoldEnabled
            ? loadHoldsListCommand()
            : promiseStub().resolve(),
          todos: ngPriorityFeedCapabilityConfiguration.config.isTodosEnabled
            ? {
                todos: loadPathTasksCommand(dateRange),
                staffTodos: loadStaffTodoCommand(dateRange)
              }
            : promiseStub().resolve(),
          reminders: ngPriorityFeedCapabilityConfiguration.config.isReminderEnabled
            ? loadAllReminderDateRangeCommand(dateRange)
            : promiseStub().resolve(),
          conversations: ngPriorityFeedCapabilityConfiguration.config.isNotificationsEnabled
            ? loadConversationsCommand()
            : promiseStub().resolve()
        })
          .then(() => {
            ngReportConfigService.getReportConfigs().then((data) => {
              const reportConfig = data || [];
              const activeReportConfig = _.filter(reportConfig, { is_active: true });
              loadAllReportsCommand(activeReportConfig);
            });
          })
          .finally(() => {
            loadActiveSurveysCommand().finally(() => {
              deferred.resolve();
            });
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/commands/load_priority_feed_data_command.ts